<template>
  <div id="app">
    <common-header v-if="hasCommonHeader"></common-header>
    <!--  v-if="this.$router.currentRoute.path.indexOf('service-center')>-1&&this.$router.currentRoute.path.indexOf('service-center-login')==-1" -->
    <service-center-header  v-if="hasServerHeader"></service-center-header>
    <div class="container">
      <router-view v-if="routerAlive"/>
    </div>
    <coin-popup></coin-popup>
    <level-popup></level-popup>
    <common-drainage-pop></common-drainage-pop>
    <common-footer></common-footer>
  </div>
</template>

<script>
import CoinPopup from '@/components/business/CoinPopup.vue'
import LevelPopup from '@/components/business/LevelPopup.vue'
import CommonDrainagePop from '@/views/components/CommonDrainagePop'
import CommonHeader from '@/views/components/Header'
import ServiceCenterHeader from '@/views/service-center/Header'
import CommonFooter from '@/views/components/Footer'
export default {
  name: 'App',
  components: { CoinPopup, LevelPopup, CommonDrainagePop, CommonHeader, CommonFooter, ServiceCenterHeader },
  provide () {
    return {
      reload: this.reload,
    }
  },
  data () {
    return {
      routerAlive: true,
    }
  },
  computed: {
    hasCommonHeader () {
      return window.location.href.indexOf('service-center') == -1
    },
    hasServerHeader () {
      return window.location.href.indexOf('service-center') > -1 && window.location.href.indexOf('service-center-login') == -1
    },
  },
  methods: {
    reload: function () {
      this.routerAlive = false
      this.$nextTick(() => {
        this.routerAlive = true
      })
    },
  },
  mounted () {
    this.$store.dispatch('app/getSystemConfig')
    this.$store.dispatch('app/getNoRenewalsConfig')
  },
}
</script>

<style lang="scss">
  @import "../public/service-center-icon/icon-one.css";
#app {
  min-width: 1280px;
  min-height: 100vh;
  font-family: "PingFangSC", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  color: #333;
  background-color: #f6f7f8;
  .ivu-layout {
    background-color: #f6f7f8;
  }
  .container {
    min-height: calc(100vh - 282px);
  }
}
</style>
